function pad(n, len, padWith = "0") {
  return String(n).padStart(len, padWith); // (2, 5, 1) => '11112'
}

export default pad;
